import { getAll } from "../utilities/querySelector.js";

document.addEventListener("DOMContentLoaded", init);
document.addEventListener("htmx:afterSettle", init);

function init() {
    const videos = [
        ...getAll(
            ":is(video, iframe)[data-fullscreen]:not([data-fullscreen-video-init])",
        ),
    ];
    const buttons = getAll(
        "button[data-fullscreen-video]:not([data-fullscreen-video-init])",
    );

    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            const videoRef = button.getAttribute("data-fullscreen-video");
            const video = videos.find((v) => v.id === videoRef);
            video.requestFullscreen();
        });
    });

    videos.forEach((video) => {
        video.addEventListener("fullscreenchange", () => {
            if (document.fullscreenElement === video) {
                video.removeAttribute("hidden");
                if (video.tagName === "IFRAME") {
                    if (isYoutube(video)) {
                        setTimeout(() => playYoutube(video), 150);
                    }
                } else {
                    setTimeout(() => video.play(), 150);
                }
            } else {
                if (video.tagName === "IFRAME") {
                    if (isYoutube(video)) {
                        pauseYoutube(video);
                    }
                } else {
                    video.pause();
                    video.currentTime = 0;
                }
                video.setAttribute("hidden", "");
            }
        });
    });
}

function isYoutube(iframe) {
    return iframe.src.includes("www.youtube.com");
}

function playYoutube(iframe) {
    iframe.contentWindow.postMessage(
        `{"event": "command","func": "playVideo","args": ""}`,
        "https://www.youtube.com",
    );
}

function pauseYoutube(iframe) {
    iframe.contentWindow.postMessage(
        `{"event": "command","func": "pauseVideo","args": ""}`,
        "https://www.youtube.com",
    );
}
